import React from "react";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import Button from "@components/Button/Button";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";

interface PrintGatepassProps {
  gatepassFlowData?: { id: string };
  onPrint?: () => void;
}

const PrintGatepass: React.FC<PrintGatepassProps> = ({ gatepassFlowData, onPrint }) => {
  const { t } = useTranslation();
  const { userActionPermissions } = useAuthStore();

  if (!checkPermission(userActionPermissions, "canPreviewGatepassRequest")) {
    return null;
  }

  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    } else {
      console.log("Print gatepass", gatepassFlowData?.id);
    }
  };

  return (
    <Button
      testId="gatepass-request-preview-print"
      variant="outlined"
      type="button"
      startIcon={<PrintOutlinedIcon />}
      className="whitespace-nowrap"
      onClick={handlePrint}
      label={<span className="normal-case font-medium">{t("gatepass.print")}</span>}
    />
  );
};

export default PrintGatepass;
